import { render, staticRenderFns } from "./index-top-banner.vue?vue&type=template&id=2354a285&scoped=true&"
var script = {}
import style0 from "./index-top-banner.vue?vue&type=style&index=0&id=2354a285&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2354a285",
  null
  
)

export default component.exports